import { Box, Drawer, List } from "@mui/material";
import Divider from "@mui/material/Divider";
import { ReactComponent as SmallNewLogo } from "assets/icons/small_new_logo.svg";
import { useCallback, useEffect, useMemo, useState } from "react";
import "./style.css";

import { ReactComponent as Clients2 } from "assets/icons/Clients_Flow_Icons/ClientsDisableIcon.svg";
import { ReactComponent as Clients1 } from "assets/icons/Clients_Flow_Icons/ClientsEnableIcon.svg";
import { ReactComponent as Catlogue2 } from "assets/sidebar/disable/catalogue.svg";
import { ReactComponent as Category2 } from "assets/sidebar/disable/category.svg";
import { ReactComponent as Collection2 } from "assets/sidebar/disable/collection.svg";
import { ReactComponent as Sets2 } from "assets/sidebar/disable/sets.svg";
import { ReactComponent as Setting2 } from "assets/sidebar/disable/setting.svg";
import { ReactComponent as Stock2 } from "assets/sidebar/disable/Stock.svg";
import { ReactComponent as Catlogue1 } from "assets/sidebar/enable/catalogue.svg";
import { ReactComponent as Category1 } from "assets/sidebar/enable/category.svg";
import { ReactComponent as Collection1 } from "assets/sidebar/enable/collection.svg";
import { ReactComponent as Sets1 } from "assets/sidebar/enable/sets.svg";
import { ReactComponent as Setting1 } from "assets/sidebar/enable/setting.svg";
import { ReactComponent as Stock1 } from "assets/sidebar/enable/Stock.svg";
import { useFilter } from "context/FilterContext";
import { useGlobalContext } from "context/GlobalContext";
import { usePermissions } from "context/PermissionsContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  findSpecificMenu,
  findSpecificSubMenu,
  forwordRouteAccordingToNewRights,
  isAllowed
} from "utils/checkUserRigths";
import { usePermissionFlags } from "utils/visionRights";

const drawerWidth = 100;

function Sidebar() {
  const permissions = usePermissions();
  const [activeItem, setActiveItem] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { setFilterValues, setFilterCount } = useFilter();
  const { setCartData } = useGlobalContext();
  const { showClients, showSettings , stockLocations} = usePermissionFlags();
  console.log("showSettings===>>>",showSettings)

  const hasMenuAccess = useCallback((displayName) => {
    if (displayName === "Clients") {
      return showClients;
    }
    const permissionName = `${displayName} Access`;
    if (displayName === "Stocks") {
      return stockLocations.length > 0 && isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), permissionName), "view");
    }
    return isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), permissionName), "view");
  },[permissions]);

  const handleItemClick = (item) => {
    setActiveItem(item);
    setFilterCount(0);
    setFilterValues({});
    sessionStorage.removeItem("CartData");
    sessionStorage.removeItem("appliedFilterValues");
    sessionStorage.removeItem("filterChangeCount");
    sessionStorage.removeItem("AppliedDateFilter");

    setCartData([]);
    window.dispatchEvent(new Event("cartUpdated"));
    localStorage.removeItem("navigatingToDesignPage");
  };

  const siderBarIconData = [
    {
      name: "Catalog",
      pathName: "Catalog",
      enableicon: <Catlogue1 />,
      disableicon: <Catlogue2 />,
    },
    {
      name: "Category",
      pathName: "Category",
      enableicon: <Category1 />,
      disableicon: <Category2 />,
    },
    {
      name: "Collection",
      pathName: "Collection",
      enableicon: <Collection1 />,
      disableicon: <Collection2 />,
    },
    {
      name: "Sets",
      pathName: "Sets",
      enableicon: <Sets1 />,
      disableicon: <Sets2 />,
    },
    {
      name: "Stocks",
      pathName: "Stock",
      enableicon: <Stock1 />,
      disableicon: <Stock2 />,
    },
    {
      name: "Clients",
      pathName: "Clients",
      enableicon: <Clients1 />,
      disableicon: <Clients2 />,
    },
  ];

  useEffect(() => {
    const path = location.pathname.split("/")[1];
    switch (path) {
      case "Catalog":
        setActiveItem("Catalog");
        break;
      case "CatalogSetting":
        setActiveItem("Catalog");
        break;
      case "Category":
        setActiveItem("Category");
        break;
      case "Collection":
        setActiveItem("Collection");
        break;
      case "Sets":
        setActiveItem("Sets");
        break;
      case "Stock":
        setActiveItem("Stocks");
        break;
      case "Clients":
        setActiveItem("Clients");
        break;
      case "client-flow":
        setActiveItem("Clients");
        break;
      case "Setting":
        setActiveItem("Setting");
        break;

      default:
        setActiveItem("");
    }
  }, [location.pathname]);

  return (
    <Drawer
      variant="permanent"
      sx={{ width: drawerWidth, flexShrink: 0, [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box", backgroundColor: "#333", color: "#fff", border: "none" } }}
    >
      <div className="sidebar-container">
        {/* <Logo
          onClick={() => {
            let nextRoute = forwordRouteAccordingToRights(permissions);
            navigate(nextRoute);
          }}
          className="sidebar-logo"
        /> */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
          <SmallNewLogo
            onClick={() => {
              let nextRoute = forwordRouteAccordingToNewRights(permissions);
              navigate(nextRoute);
            }}
            className="sidebar-logo"
          />
        </div>
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: "0" }} width={"100%"}>
          <Divider orientation="horizontal" flexItem style={{ borderColor: "#444444", width: "100%", marginTop: "0", height: "10px" }} />
        </Box>
        <List>
          <div className="sidebar-icons-space">
            {siderBarIconData.map((data, index) => {
              const findPage = hasMenuAccess(data.name);
              // const findPage = hasAccessPage(findSpecificPage(data.name, permissions), "view");
              //  const findPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions),"Catalog Access",data.name),"view");

              if (!findPage) {
                return null;
              }
              return (
                <Link to={"/" + data.pathName} className="sidebar-custom-link" key={index}>
                  <div className="custom-list-item" onClick={() => handleItemClick(data.name)}>
                    {activeItem === data.name ? data.enableicon : data.disableicon}

                    <span className={`sidebar-icon-name ${activeItem === data.name ? "sidebar-icon-name-active" : ""}`}>{data.name}</span>
                  </div>
                </Link>
              );
            })}
          </div>
        </List>

        {/* {showSettings && ( */}
          <Link to="/Setting" className="sidebar-custom-link">
            <div className="custom-list-item" onClick={() => handleItemClick("Setting")}>
              {activeItem === "Setting" ? <Setting1 /> : <Setting2 />}

              <span className={`sidebar-icon-name ${activeItem === "Setting" ? "sidebar-icon-name-active" : ""}`}>Setting</span>
            </div>
          </Link>
        {/* )} */}
      </div>
    </Drawer>
  );
}

export default Sidebar;
